<div>
        <article *ngIf="bezuegestelle$ | async as bezuegestelle" class="ba-tile">
            <section>
                <div class="bezuegestelle">
                    <h2 class="header-2" id="ct_information_txt">Informationen zu Ihrer Bezügestelle</h2>

                    <div>
                        <span id="ct_bezuegestellennummerTitle_txt"><strong>Nummer: </strong></span>
                        <span id="ct_bezuegestellennummer_txt">{{ bezuegestelle.bezuegestellennummer }}</span>
                    </div>

                    <div>
                        <span id="ct_bezuegestellenbezeichnungTitle_txt"><strong>Bezeichnung: </strong></span>
                        <span id="ct_bezuegestellenbezeichnung_txt">{{ bezuegestelle.bezuegestellenbezeichnung }}</span>
                    </div>

                    <div>
                        <span id="ct_anschriftTitel_txt"><strong>Anschrift: </strong></span>
                        <span id="ct_anschrift_txt">{{ anschriftBezuegestelle(bezuegestelle) }}</span>
                    </div>
                </div>
            </section>
        </article>
    <article class="ba-content-article">
        <router-outlet></router-outlet>
    </article>
</div>
